import React from 'react';
import Bio from '../components/Bio'; 
import Projects from '../components/Projects/Projects'; 
import Experience from '../components/Experience/Experience';
import About from '../components/About'; 
import Footer from '../components/Footer'; 
import useDocumentTitle from '../../hooks/useDocumentTitle'; 
import '../../index.css';
function Home({ title }) {
  useDocumentTitle(title); 

  return (
    <div className="mx-auto min-h-screen max-w-screen-xl px-6 py-12 font-sans md:px-12 md:py-20 lg:px-24 lg:py-0">
      <div className="lg:flex lg:justify-between lg:gap-4">
        <Bio />
        <main id="content" className="pt-24 lg:w-1/2 lg:py-24">
          <About />
          <Experience />
          <Projects />
          <Footer />
        </main>
      </div>
    </div>
  );
}

export default Home;